module.exports = __webpack_public_path__ + "static/media/trackOrderImg.d63f6175.svg";